import React from 'react';
import { Link } from 'react-router-dom';

const BackToDashboardButton = () => {
  return (
    <div className="text-center mt-5">
      <Link to="/race" className="btn btn-outline-secondary">
        ← Back to Dashboard
      </Link>
    </div>
  );
};

export default BackToDashboardButton;